import { defineStore } from "pinia";

export type ConfirmationTone = "default" | "danger" | "financial";

export interface ConfirmationRequest {
  cancelLabel: string;
  confirmLabel: string;
  consequence?: string | undefined;
  id: string;
  message: string;
  requireTypedText?: string | undefined;
  title: string;
  tone: ConfirmationTone;
}

export interface ConfirmOptions {
  cancelLabel?: string | undefined;
  confirmLabel?: string | undefined;
  consequence?: string | undefined;
  message: string;
  requireTypedText?: string | undefined;
  title: string;
  tone?: ConfirmationTone | undefined;
}

export const useMerchantConfirmationStore = defineStore("merchant-confirmation", {
  state: (): { pending: ConfirmationRequest | null; resolver?: (confirmed: boolean) => void } => ({
    pending: null,
  }),
  actions: {
    request(options: ConfirmOptions): Promise<boolean> {
      this.cancelActiveRequest();
      this.pending = toConfirmationRequest(options);
      return new Promise((resolve) => {
        this.resolver = resolve;
      });
    },
    accept(): void {
      this.resolveActiveRequest(true);
    },
    cancel(): void {
      this.resolveActiveRequest(false);
    },
    cancelActiveRequest(): void {
      if (this.resolver === undefined) return;
      this.resolveActiveRequest(false);
    },
    resolveActiveRequest(confirmed: boolean): void {
      this.resolver?.(confirmed);
      this.pending = null;
      delete this.resolver;
    },
  },
});

function toConfirmationRequest(options: ConfirmOptions): ConfirmationRequest {
  return {
    cancelLabel: options.cancelLabel ?? "Cancel",
    confirmLabel: options.confirmLabel ?? "Confirm",
    consequence: options.consequence,
    id: crypto.randomUUID(),
    message: options.message,
    requireTypedText: options.requireTypedText,
    title: options.title,
    tone: options.tone ?? "default",
  };
}
